<template>
    <div>
        <div class="mb-4">
            <h3 class="font-weight-bold">
                {{ event.location.name }}
            </h3>
            <div v-if="event.location.room">
                {{ event.location.room }}
            </div>
            <div
                v-if="event.location.address.district &&
                    event.location.address.district !== event.location.address.city">
                {{ event.location.address.district }}
            </div>
            <div style="white-space: pre-line">
                {{ event.location.address.addressAsString }}
            </div>
            <div v-if="event.location.hompage">
                <a :href="event.location.hompage">{{ event.location.hompage }}</a>
            </div>
            <div v-if="event.location.lowBarrier && event.location.lowBarrier === 1">
                <font-awesome-icon
                    icon="wheelchair"
                    class="mr-1" />
                {{ $t('iFrame.lowBarrier') }}
            </div>
        </div>

        <div v-if="!userHasGivenMapboxConsent">
            <base-button
                type="primary"
                @click="$store.commit('iframe/userHasGivenMapboxConsent')">
                {{ $t('iFrame.showMap') }}
            </base-button>
            <p
                class="mt-2 text-muted text-xs"
                style="max-width: 700px">
                <font-awesome-icon
                    icon="info-circle"
                    class="mr-1" />
                <i>{{ $t('iFrame.mapboxLegalNotice') }}</i>
                <a
                    href="https://www.mapbox.com/legal/privacy/"
                    target="_blank"
                    title="https://www.mapbox.com/legal/privacy/">
                    mapbox.com/legal/privacy
                </a>
            </p>
        </div>
        <BaseMap
            v-else
            class="map-component"
            :markers="[{
                name: event.location.name || $t('iFrame.eventPlace'),
                address: event.location.address.addressAsString,
                position: getMarkerPosition(),
            }]"
            :default-map-position="getMarkerPosition()"
            :marker-default-name="$t('iFrame.noEventPlaceFound')"
            :event-id="event.id" />
    </div>
</template>

<script>
import lazyLoadedComponentsMixin from '@/mixins/lazyLoadedComponentsMixin'

export default {
    name: "EventEntryLocation",
    mixins: [lazyLoadedComponentsMixin],
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    computed: {
        userHasGivenMapboxConsent() {
            return this.$store.state.iframe.consentGiven
        }
    },
    methods: {
        getMarkerPosition() {
            if (!this.event?.location) return [9.106596, 48.7264186]
            return [
                this.event.location.longitude,
                this.event.location.latitude
            ]
        }
    }
}
</script>

<style scoped>
.map-component {
    aspect-ratio: 1.5;
    max-width: 700px;
    width: 100%;
}
</style>
